<script context="module">
    import { env } from '../Environment.svelte';

    export async function fetchPromos(productsBody) {
        var myHeaders = new Headers();
        myHeaders.append('x-api-key', env[env.stage].api.key);
        myHeaders.append('Content-Type', 'application/json');

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(productsBody),
        };

        const response = await fetch(
            env[env.stage].api.url +
                'apikey/izzi/arc/camunda/purchase/v2/quote',
            requestOptions
        )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    return { promos: [] };
                }
            })
            .then((result) => {
                return result.promos == null
                    ? (result.promos = [])
                    : result.promos;
            })
            .catch((error) => {
                return error;
            });
        return await response;
    }
</script>
